import React from 'react';
import SelectionDropdown from '../SelectionDropdown/SelectionDropdown';
import { useCountrySelectionItems } from './useCountrySelectionItems';
import type { CountrySelectionDropdownProps } from './countrySelectionTypes';

/** Desktop country / dial-code picker: the shared selection items rendered by SelectionDropdown. */
const CountrySelectionDropdown: React.FC<CountrySelectionDropdownProps> = (props) => {
  const {
    isOpen,
    onClose,
    closeOnOutsideClick,
    outsideClickIgnoreRefs,
    className = '',
    listboxId,
  } = props;
  const {
    isRegionCode,
    showFlags,
    searchQuery,
    setSearchQuery,
    filteredItems,
    isItemSelected,
    selectItem,
    texts,
  } = useCountrySelectionItems(props);

  const items = filteredItems.map((item, index) => ({
    key: `${item.code}-${item.countryCode || index}`,
    label: item.name,
    detail: isRegionCode ? `+${item.code}` : undefined,
    iconSrc: item.flagSrc,
    selected: isItemSelected(item),
    value: item,
  }));

  return (
    <SelectionDropdown
      isOpen={isOpen}
      onClose={onClose}
      items={items}
      onSelect={(item) => selectItem(item.value)}
      searchQuery={searchQuery}
      onSearchQueryChange={setSearchQuery}
      texts={{
        searchPlaceholder: texts.searchPlaceholder,
        listLabel: texts.title,
        emptyTitle: texts.emptyTitle,
        emptySubtitle: texts.emptySubtitle,
      }}
      showIcons={showFlags}
      className={[isRegionCode ? '_region-code' : '_country', className].filter(Boolean).join(' ')}
      closeOnOutsideClick={closeOnOutsideClick}
      outsideClickIgnoreRefs={outsideClickIgnoreRefs}
      listboxId={listboxId}
    />
  );
};

export default CountrySelectionDropdown;
